/**
 * Created by tofael on 7/18/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import api from '../utility/api';
import List from '../screens/list/';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';

class AdminsList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      admins: [],
      sortPref: defaultSort,
      pageSize
    };
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.ADMIN);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'userName',
          desc: false
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.ADMIN);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.ADMIN, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.ADMIN);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.ADMIN, currentPreference);
  }

  componentDidMount() {
    this.props.dispatch(asyncStart());
    api.getAdmins()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({admins: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  getRole(user) {
    let roles = '';

    if(user.admin) {
      roles = 'Admin';
    }
    else if(user.super_admin) {
        roles = 'Super Admin';
    }
    else if(user.rmg) {
        roles = 'RMG'
    }
    else if(user.scheduler) {
      roles = 'Scheduler'
    }
    return roles;
  }

  render() {

    let columns = [{
      Header: 'Id',
      accessor: 'id',
      show: false
    }, {
      id: 'userName',
      Header: 'Name',
      accessor: d => d.name
    }, {
      id: 'userPhone',
      Header: 'Phone',
      accessor: d => d.phone
    }, {
      id: 'userEmail',
      Header: 'Email',
      accessor: d => d.email
    }, {
      id: 'status',
      Header: 'Status',
      accessor: d => d.locked ? 'locked' : 'active'
    },
    {
      id: 'role',
      Header: 'Role',
      accessor: d => this.getRole(d)
    }
  ];

    let {admins, sortPref, pageSize} = this.state;
    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: admins,
      columns,
      isLoading,
      noDataText: 'No admin found',
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            if (rowInfo)
              hashHistory.push('/user/' + rowInfo.row.id)
          }
        }
      }
    };

    return (
      <List
        title="Admins"
        addNewBtnLabel="Add new admin"
        reactTableProps={reactTableProps}
        onCreateNew={() => hashHistory.push('create-admin')}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(AdminsList);


// WEBPACK FOOTER //
// ./src/containers/admins.js